import { IApplicationState } from '../../types/redux';
import { getResidentialComplexById } from '../residentialComplexes';
import { getMinPriceLabel } from '../../containers/MinPriceLabel/helpers';
import { formatSubwayTime, getMovingType } from '../../utils/pikPlus';
import { IPikPlus } from '../../types/pikPlus';

export const getPikPlus =
  (id: number) =>
  (state: IApplicationState): IPikPlus | null => {
    const residentialComplex = getResidentialComplexById(state, id);

    return residentialComplex
      ? {
          id,
          url: residentialComplex.publicUrl || '#',
          title: residentialComplex.title || '',
          description: residentialComplex.description || '',
          imageUrl: residentialComplex.fullImgUrl || '',
          minPrice: getMinPriceLabel(residentialComplex.minPrice, '₽') || '',
          finishInfo: residentialComplex.finishInfo?.label || '',
          promoLabel: residentialComplex.promoLabel || '',
          equipmentOptions: residentialComplex.equipmentOptions || [],
          subway: residentialComplex.undergroundInfo
            ? {
                lineColor: residentialComplex.undergroundInfo.lineColor || null,
                title: residentialComplex.undergroundInfo.title || null,
                timeDisplay: formatSubwayTime(residentialComplex.undergroundInfo.timeDisplay),
                movingType: getMovingType(residentialComplex.undergroundInfo.timeDisplay),
              }
            : null,
        }
      : null;
  };
